import { render, staticRenderFns } from "./FunctionView.vue?vue&type=template&id=10b91c9a&scoped=true"
import script from "./FunctionView.vue?vue&type=script&lang=js"
export * from "./FunctionView.vue?vue&type=script&lang=js"
import style0 from "./FunctionView.vue?vue&type=style&index=0&id=10b91c9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b91c9a",
  null
  
)

export default component.exports